module.exports = __webpack_public_path__ + "static/theme-editor-header-a44fae033e05ea502ac705face393cdc.png";